export enum ComponentClassGroupDetailMenuEnum {
  DATA_FIELD_GROUP = 'DATA_FIELD_GROUP',
  CLASSES = 'CLASSES'
}

export interface ComponentClassGroupDetailMenuEntry {
  value: ComponentClassGroupDetailMenuEnum;
  label: string;
}

export const COMPONENT_CLASS_GROUP_DETAIL_MENU_ENTRIES: ComponentClassGroupDetailMenuEntry[] = [
  {
    value: ComponentClassGroupDetailMenuEnum.DATA_FIELD_GROUP,
    label: 'DESIGN_B.COMPONENT_CLASS_GROUP.DETAIL_PAGE.MENU.DATA_FIELD_GROUP'
  },
  {
    value: ComponentClassGroupDetailMenuEnum.CLASSES,
    label: 'DESIGN_B.COMPONENT_CLASS_GROUP.DETAIL_PAGE.MENU.CLASSES'
  }
];
